export enum ProcessStatusEnum {
  Created = 0,
  InProgress = 1,
  Withheld = 2,
  Completed = 3,
  Canceled = 4,
  Failed = 5
}
